import React from "react";
import { saveComponent } from "../../../services/projectComponentService";
import { notifications } from "../../../utils/messages";
import { useSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import { useForm } from "../../../hooks/useForm";
import TitleComponent from "../../common/titleComponent";

const AddProjectComponentForm = (props) => {
  const initialState = {
    name: "",
    goal: "",
    project_slug: props.projectSlug,
  };
  const [formValues, handleInputChange, reset] = useForm(initialState);
  const { name, goal } = formValues;
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    reset(name);
    reset(goal);
  };

  const handleSubmit = async () => {
    try {
      await saveComponent(formValues);
      enqueueSnackbar(notifications.SUCCESS, { variant: "success" });
      handleClose();
      //setState({ ...initialState });
      props.populateComponents();
    } catch (ex) {
      enqueueSnackbar(`${ex.response.data.message}`, { variant: "error" });
    }
  };

  return (
    <div>
      <TitleComponent entity={"EJECUCIÓN PRESUPUESTARIA"} />
      <small style={{ color: "white" }}>
        {" "}
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
      </small>

      <TitleComponent entity={" "} />

      <Button
        className="addComponent"
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
      >
        Agregar Componente
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Agregar componente</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            name="name"
            label="Nombre del componente *"
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            value={name}
            onChange={handleInputChange}
            helperText={"Máximo 5000 caracteres"}
          />
          <TextField
            margin="dense"
            name="goal"
            label="Escriba la meta"
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            multiline
            maxRows="3"
            value={goal}
            onChange={handleInputChange}
          />
          <Button
            onClick={handleSubmit}
            color="primary"
            className="btn btn-guardar"
            variant="contained"
            margin="normal"
            size="medium"
          >
            Guardar
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddProjectComponentForm;
